<template>
  <div class="n-graph" :id="id">
    <h2>222</h2>
  </div>
</template>

<script>
import { Graph, Dom } from '@antv/x6'
import { initGraphOptions } from '../../js/strategicMap/index'

export default {
  name: '',
  props: [

  ],
  data () {
    return {
      id: 'test1',
      iGrap: null,
      graph: null
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      let strategicMap = document.getElementById('test1')
      this.graph = new Graph({
        container: strategicMap,
        autoResize: true,
        grid: true,
        mousewheel: {
          enabled: true,
          zoomAtMousePosition: true,
          modifiers: 'ctrl',
          minScale: 0.5,
          maxScale: 3
        },
        selecting: {
          enabled: true
        // rubberband: true
        },
        transforming: {
          clearAll: true,
          clearOnBlankMouseDown: true
        },
        translating: {
          restrict: true// 节点移动不能超出画布
        },
        panning: {
          enabled: true
        },
        keyboard: true,
        // resizing: true,
        snapline: true, // 辅助对准线
        connecting: {
          anchor: 'orth'
        },
        interacting: false
      })
      this.iGrap = initGraphOptions({ graph: this.graph })
      this.iGrap.graphRegisterEdge()
      this.iGrap.graphRegisterNode()
      this.iGrap.graphRegisterComponents()
      this.initData()
    })
  },
  watch: {

  },
  methods: {
    initData () {
      let { createEdge, createNode, setNodeOrgChildNode } = this.iGrap

      const orgNodes = [
        createNode('酷开公司', 'Pierre Omidyar'),
        createNode('大内容事业部', 'Devin Wenig'),
        createNode('数字营销事业部', 'Devin Wenig'),
        createNode('电视传媒影视部', 'Devin Wenig')
      ]

      const edges = [
        createEdge(orgNodes[0], orgNodes[1]),
        createEdge(orgNodes[0], orgNodes[2]),
        createEdge(orgNodes[0], orgNodes[3])
      ]
      this.graph.resetCells([...edges, ...orgNodes])
      this.iGrap.layout(orgNodes, edges)

      this.graph.centerContent()
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.n-graph
  width 500px
  height 500px
  border 2px solid black
</style>
